module.exports = __webpack_public_path__ + "static/media/page-body-sidebar.3f013d8a.png";